import type { ReactElement } from 'react'

// (react import removed: only createContext was used)
import { createSharedContext } from '@twistopayments/design-system/utils'

export type Message = string | ReactElement

export type ToastVariant = 'success' | 'warning' | 'error' | 'info'

export type ShowToastArgs = {
  message: Message
  variant: ToastVariant
}

/**
 * Context
 */

type ContextValue = {
  showToast: (args: ShowToastArgs) => void
}

export const Context = createSharedContext<ContextValue | undefined>('components/atoms/toast/toast.context#0', undefined)
